import React, { useEffect } from 'react';
import { useUnleashContext } from '@unleash/proxy-client-react';

import { getAuthState } from '../../store/AuthSlice';
import { useAppSelector } from '../../hooks';

const FeatureFlagUpdater = (): React.ReactElement => {
  const updateContext = useUnleashContext();

  const authState = useAppSelector(getAuthState);

  const { user } = authState;

  useEffect(() => {
    if (user && user._id) {
      updateContext({ userId: user._id }).then();
    }
  }, [user]);

  return <></>;
};

export default FeatureFlagUpdater;
